var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _g2, _path8, _path9, _path10, _path11, _path12, _g3, _path13, _g4, _g5, _path14, _path15, _path16, _path17, _g6, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _g7, _path27, _circle, _path28, _path29, _path30, _path31, _g8, _path32;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWporgAstra(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 402.5 349.1",
    style: {
      enableBackground: "new 0 0 402.5 349.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.2;fill:#300B8D;}\n\t.st1{opacity:0.3;fill:#000072;enable-background:new    ;}\n\t.st2{fill:#240E8C;stroke:#751DFF;stroke-width:0.5;stroke-miterlimit:10;}\n\t.st3{fill:#6900FF;}\n\t.st4{opacity:0.5;}\n\t.st5{fill:url(#SVGID_1_);}\n\t.st6{fill:url(#SVGID_2_);}\n\t.st7{fill:url(#SVGID_3_);}\n\t.st8{fill:#0E074F;}\n\t.st9{fill:#6A03C1;}\n\t.st10{opacity:0.4;enable-background:new    ;}\n\t.st11{fill:#000072;}\n\t.st12{opacity:0.2;}\n\t.st13{fill:#FF7884;}\n\t.st14{opacity:0.9;fill:url(#SVGID_4_);}\n\t.st15{opacity:0.9;fill:url(#SVGID_5_);}\n\t.st16{opacity:0.9;fill:url(#SVGID_6_);}\n\t.st17{opacity:0.9;fill:url(#SVGID_7_);}\n\t.st18{fill:#13A8E7;}\n\t.st19{fill:#FFFFFF;}\n\t.st20{fill-rule:evenodd;clip-rule:evenodd;fill:#CE844D;}\n\t.st21{fill-rule:evenodd;clip-rule:evenodd;fill:#0B0456;}\n\t.st22{opacity:0.6;}\n\t.st23{opacity:0.2;fill-rule:evenodd;clip-rule:evenodd;fill:#A6A4F7;enable-background:new    ;}\n\t.st24{fill-rule:evenodd;clip-rule:evenodd;fill:#140666;}\n\t.st25{opacity:0.7;}\n\t.st26{fill-rule:evenodd;clip-rule:evenodd;fill:#300B8D;}\n\t.st27{fill-rule:evenodd;clip-rule:evenodd;fill:#1E0489;}\n\t.st28{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_8_);}\n\t.st29{fill-rule:evenodd;clip-rule:evenodd;fill:url(#Sleeve_2_);}\n\t.st30{fill-rule:evenodd;clip-rule:evenodd;fill:url(#Clothes_2_);}\n\t.st31{fill-rule:evenodd;clip-rule:evenodd;fill:#FCBB89;}\n\t.st32{fill-rule:evenodd;clip-rule:evenodd;fill:#190649;}\n\t.st33{fill-rule:evenodd;clip-rule:evenodd;fill:#176084;}\n\t.st34{fill-rule:evenodd;clip-rule:evenodd;fill:url(#shoe_4_);}\n\t.st35{fill-rule:evenodd;clip-rule:evenodd;fill:url(#shoe_5_);}\n\t.st36{fill-rule:evenodd;clip-rule:evenodd;fill:url(#Skirt_1_);}\n\t.st37{fill-rule:evenodd;clip-rule:evenodd;fill:url(#Sleeve_3_);}\n\t.st38{fill:url(#SVGID_9_);}\n\t.st39{fill:none;stroke:#FFFFFF;stroke-width:2;stroke-miterlimit:10;}\n\t.st40{opacity:0.3;fill:#FFFFFF;}\n\t.st41{opacity:0.5;fill:#FFFFFF;}\n\t.st42{fill-rule:evenodd;clip-rule:evenodd;fill:#FFAF78;}\n\t.st43{fill-rule:evenodd;clip-rule:evenodd;fill:url(#Clothes_3_);}\n\t.st44{opacity:0.9;fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_10_);}\n\t.st45{fill:#E0CCFF;}\n\t.st46{fill:url(#SVGID_11_);}\n")), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M358.2,42.6c38.9,50.2,24.6,127.7-4.2,179.5c-21.9,39.4-54.5,62.9-92.1,72.5c-31.1,7.9-65.7,9.5-97.3,5.6 c-29.8-3.7-59.4-13.8-84.7-34.1c-11.1-8.9-21.3-19.7-30-31.9c-8.1-11.4-19.1-27.3-21.4-42.6c-0.8-5.4,0.2-11.7,3.7-15.1 c4.4-4.3,10.7-3,16.1-1.1c6.9,2.5,13.7,5.7,20.3,9.4c12.7,7.4,22.9,12.1,35.8,1.9c18.7-14.7,33.1-36.9,45.2-59.5 c12.7-23.6,22.5-49.8,36.5-72.4c30.5-49.2,89.4-69.2,135.4-43.6C335.4,19,348.1,29.5,358.2,42.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M374.4,38v241.7c0,4.1-3.3,7.4-7.4,7.4H63.7c-4.1,0-7.4-3.3-7.4-7.4V38c0-4.1,3.3-7.4,7.4-7.4H367 C371.1,30.6,374.4,33.9,374.4,38z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M368.5,30.6v241.7c0,4.1-3.3,7.4-7.4,7.4H57.8c-4.1,0-7.4-3.3-7.4-7.4V30.6c0-4.1,3.3-7.4,7.4-7.4h303.3 C365.2,23.2,368.5,26.5,368.5,30.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M50.4,47.2h318.1v232.5H53.4c-1.7,0-3-1.3-3-3V47.2z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 64.2079,
    y1: 35.2715,
    x2: 69.8079,
    y2: 35.2715
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F2F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F2F2F2",
      stopOpacity: 0.64
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M69.8,35.3c0,1.5-1.2,2.8-2.8,2.8s-2.8-1.2-2.8-2.8s1.2-2.8,2.8-2.8S69.8,33.7,69.8,35.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 74.5079,
    y1: 35.2715,
    x2: 80.1079,
    y2: 35.2715
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F2F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F2F2F2",
      stopOpacity: 0.64
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M80.1,35.3c0,1.5-1.2,2.8-2.8,2.8s-2.8-1.2-2.8-2.8s1.2-2.8,2.8-2.8S80.1,33.7,80.1,35.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 84.8079,
    y1: 35.2715,
    x2: 90.4079,
    y2: 35.2715
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F2F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F2F2F2",
      stopOpacity: 0.64
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M90.4,35.3c0,1.5-1.2,2.8-2.8,2.8s-2.8-1.2-2.8-2.8s1.2-2.8,2.8-2.8S90.4,33.7,90.4,35.3z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M74.3,235.6h269.9c7.1,0,12.9-5.8,12.9-12.9V103.6c0-7.1-5.8-12.9-12.9-12.9H74.3c-7.1,0-12.9,5.8-12.9,12.9 v119.1C61.3,229.8,67.1,235.6,74.3,235.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M75.4,92.3h264.6c8,0,14.4,6.4,14.4,14.4v49.4c0,2.1-1.3,3.9-3.3,4.6l0,0c-1,0.4-1.7,1.3-1.7,2.4l0,0 c0,1.1,0.7,2.1,1.7,2.4l0,0c1.9,0.7,3.3,2.5,3.3,4.6v49.4c0,7.9-6.4,14.4-14.4,14.4H77.7c-7.9,0-14.4-6.4-14.4-14.4V106.7 C63.3,98.8,67.4,92.3,75.4,92.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M166.2,92.3h174.9c8,0,14.5,6.4,14.5,14.4v49.4c0,2.1-1.3,3.9-3.3,4.6c-1,0.4-1.7,1.3-1.7,2.4l0,0 c0,1.1,0.7,2.1,1.7,2.4l0,0c1.9,0.7,3.3,2.5,3.3,4.6v49.4c0,7.9-6.4,14.4-14.5,14.4H166.2V92.3z"
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M154.2,147.2H128c-1,0-2-0.5-2-1.1c0-0.7,0.8-1.1,2-1.1h26.2c1,0,2,0.5,2,1.1 C156.2,146.7,155.2,147.2,154.2,147.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M154.2,152.8H128c-1,0-2-0.5-2-1.1c0-0.7,0.8-1.1,2-1.1h26.2c1,0,2,0.5,2,1.1 C156.2,152.3,155.2,152.8,154.2,152.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M141.5,158.4H128c-1,0-2-0.5-2-1.1c0-0.7,0.8-1.1,2-1.1h13.5c1,0,2,0.5,2,1.1 C143.5,158,142.5,158.4,141.5,158.4z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M114.3,211H81c-1.9,0-3.5-1.5-3.5-3.5v-22.9c0-1.9,1.5-3.5,3.5-3.5h33.3c1.9,0,3.5,1.5,3.5,3.5v22.9 C117.8,209.5,116.2,211,114.3,211z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M154.2,191.1H128c-1,0-2-0.5-2-1.2s0.8-1.2,2-1.2h26.2c1,0,2,0.5,2,1.2S155.2,191.1,154.2,191.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M154.2,197.3H128c-1,0-2-0.5-2-1.2s0.8-1.2,2-1.2h26.2c1,0,2,0.5,2,1.2S155.2,197.3,154.2,197.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M141.5,203.4H128c-1,0-2-0.5-2-1.2c0-0.7,0.8-1.2,2-1.2h13.5c1,0,2,0.5,2,1.2 C143.5,202.9,142.5,203.4,141.5,203.4z"
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 301.792,
    y1: -1.7694,
    x2: 303.7467,
    y2: -3.0726
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF0E95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02652842,
    style: {
      stopColor: "#FF1F8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08537972,
    style: {
      stopColor: "#FF3E7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    style: {
      stopColor: "#FF5A6C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2274,
    style: {
      stopColor: "#FF705F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3153,
    style: {
      stopColor: "#FF8056"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.424,
    style: {
      stopColor: "#FF8C50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5766,
    style: {
      stopColor: "#FF934C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF954B"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M208.8,70.4h-26.4c-0.6,0-1.1-0.6-1.1-1.4c0-0.8,0.5-1.4,1.1-1.4h26.4c0.6,0,1.1,0.6,1.1,1.4 C209.9,69.8,209.4,70.4,208.8,70.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 313.6202,
    y1: 15.973,
    x2: 315.575,
    y2: 14.6699
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF0E95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02652842,
    style: {
      stopColor: "#FF1F8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08537972,
    style: {
      stopColor: "#FF3E7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    style: {
      stopColor: "#FF5A6C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2274,
    style: {
      stopColor: "#FF705F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3153,
    style: {
      stopColor: "#FF8056"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.424,
    style: {
      stopColor: "#FF8C50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5766,
    style: {
      stopColor: "#FF934C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF954B"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M247.2,70.4h-26.4c-0.6,0-1.1-0.6-1.1-1.4c0-0.8,0.5-1.4,1.1-1.4h26.4c0.6,0,1.1,0.6,1.1,1.4 C248.3,69.8,247.8,70.4,247.2,70.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 325.4483,
    y1: 33.715,
    x2: 327.403,
    y2: 32.4119
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF0E95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02652842,
    style: {
      stopColor: "#FF1F8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08537972,
    style: {
      stopColor: "#FF3E7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    style: {
      stopColor: "#FF5A6C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2274,
    style: {
      stopColor: "#FF705F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3153,
    style: {
      stopColor: "#FF8056"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.424,
    style: {
      stopColor: "#FF8C50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5766,
    style: {
      stopColor: "#FF934C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF954B"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M285.7,70.4h-26.4c-0.6,0-1.1-0.6-1.1-1.4c0-0.8,0.5-1.4,1.1-1.4h26.4c0.6,0,1.1,0.6,1.1,1.4 C286.8,69.8,286.3,70.4,285.7,70.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 337.2764,
    y1: 51.4573,
    x2: 339.2312,
    y2: 50.1541
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF0E95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02652842,
    style: {
      stopColor: "#FF1F8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08537972,
    style: {
      stopColor: "#FF3E7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    style: {
      stopColor: "#FF5A6C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2274,
    style: {
      stopColor: "#FF705F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3153,
    style: {
      stopColor: "#FF8056"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.424,
    style: {
      stopColor: "#FF8C50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5766,
    style: {
      stopColor: "#FF934C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF954B"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M324.1,70.4h-26.4c-0.6,0-1.1-0.6-1.1-1.4c0-0.8,0.5-1.4,1.1-1.4h26.4c0.6,0,1.1,0.6,1.1,1.4 C325.2,69.8,324.7,70.4,324.1,70.4z"
  })))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M259.4,175.9c-9.4,0-17-7.6-17-17s7.6-17,17-17s17,7.6,17,17C276.3,168.3,268.7,175.9,259.4,175.9z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M269.2,158.2l-14.5-8.4c-0.1-0.1-0.3-0.1-0.4,0c-0.1,0.1-0.2,0.2-0.2,0.4v16.7c0,0.2,0.1,0.3,0.2,0.4 c0.1,0,0.1,0.1,0.2,0.1c0.1,0,0.1,0,0.2-0.1l7.3-4.1l7.2-4.2c0.1-0.1,0.2-0.2,0.2-0.4C269.4,158.4,269.3,158.2,269.2,158.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "humaaans_x2F_sitting-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "A-Human_x2F_Sitting",
    transform: "translate(190.000000, 200.500000) scale(-1, 1) translate(-190.000000, -200.500000) translate(40.000000, 24.000000)"
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Head_x2F_Front_x2F_Rad",
    transform: "translate(82.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Head_1_",
    transform: "translate(54.000000, 31.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M-162.4,149.3c-2.5-2.7-4.2-6-3.9-9.8c0.8-10.7,16.9-8.4,20.1-3c3.1,5.4,2.8,19.2-1.3,20.1 c-1.6,0.4-5.1-0.6-8.6-2.5l2.2,14.4h-13L-162.4,149.3z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "hair_1_",
    className: "st21",
    d: "M-118,166.9c-0.4-0.4-0.6-0.9-0.8-1.5c-0.2-0.5-0.4-1.1-0.5-1.7c-0.3-1.1-0.3-2.4,0.6-3.3 c0.7-0.7,1.7-1,2.7-1.1c0.6,0,1.3,0,1.9,0.2c0.6,0.2,1.1,0.6,1.7,0.8c0-1.2,0.2-2.5,0.9-3.5c0.6-1,1.7-1.6,2.8-1.7 c1.2-0.2,2.4,0.1,3.4,0.6c0.3,0.1,0.5,0.3,0.8,0.4c0.2,0.1,0.4,0.3,0.7,0.3c0.3,0.1,0.4-0.1,0.6-0.3c0.2-0.2,0.5-0.4,0.7-0.6 c1.1-0.8,2.6-1.1,3.9-0.6c0.6,0.2,1.2,0.6,1.6,1.1c0.4,0.4,0.6,1.1,1.1,1.4c0.2,0.1,0.4,0,0.6-0.2c0.3-0.2,0.6-0.4,0.9-0.6 c0.4-0.3,0.9-0.5,1.3-0.6c0.7-0.1,1.7-0.1,1.9,0.7c0.1,0.3,0,0.7,0,1c0,0.4-0.1,0.9-0.1,1.3c0,0.3-0.1,0.7-0.1,1 c0,0.2-0.1,0.5-0.1,0.7c0.1,0.2,0.6,0.1,0.8,0.1c0.4,0,0.8,0.1,1.2,0.2c0.3,0.1,0.6,0.3,0.7,0.6c0.1,0.2,0.1,0.4,0,0.6 c0,0.2,0,0.3,0,0.6c0.5-0.2,2.4-0.8,2.6,0.1c0.1,0.3-0.1,0.6-0.2,0.9c-0.2,0.4-0.5,0.8-0.9,1.2c-0.7,0.8-1.4,1.5-2.3,2 c1,0.4,1.2,1.6,0.4,2.3c-0.4,0.3-0.9,0.4-1.4,0.4c-0.2,0-0.4-0.1-0.6,0c-0.1,0-0.2,0.1-0.3,0.1c-0.7,0-1.4-0.1-2.1-0.2 c-1.2-0.2-2.3-0.8-3.2-1.5c-0.2-0.2-0.4-0.3-0.7-0.3c-0.3,0-0.5,0.1-0.8,0.1c-0.7,0-1.4-0.3-2-0.5c0,0.8-0.3,1.8-0.7,2.5 c-0.3,0.6-0.9,0.7-1.5,0.8c-2,0.2-1.6,0.2-3.6,0.2c1.9,0.4,1.6,0.4,3.5,0.8c0.9,0.2,0.2,0.7-0.2,1.1c-0.6,0.6-1.1,1.4-1.4,2.2 c-0.9-1.1-2.6-1.9-4.1-1.5c-1.6,0.4-2.8,2.4-1.7,3.9c0.6,0.8,1.7,1.2,2.6,1.5c-0.7,0.7-0.9,1.7-1.3,2.5c-0.2,0.4-0.5,0.9-1,1 c-0.2,0.1-0.4,0.1-0.5,0.2c-0.2,0.2-0.2,0.3-0.4,0.5c-0.9,0.6-2.2,0.5-3-0.2c-0.7-0.7-0.5-1.7,0.1-2.4c-0.9-0.4-2.6-0.8-2.2-2.1 c-2-0.1-6.8-3.1-4.2-5.3c-1.5-0.8-2.8-2.6-1.9-4.3C-121.1,167.6-119.4,167-118,166.9"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Bottom_x2F_Sitting_x2F_Skinny-Jeans-1",
    transform: "translate(0.000000, 187.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Objects_x2F_Seat_x2F_Cube",
    transform: "translate(10.000000, 42.000000)",
    className: "st22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Seat",
    transform: "translate(55.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Seat-Stuff",
    className: "st23",
    points: "-114.2,24.7 -83.7,24.7 -72.1,95.5 -127.5,95.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Seat-Stuff_1_",
    className: "st23",
    points: "-114.2,24.7 -102.7,24.7 -95.9,95.5 -127.5,95.5  "
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Skin_2_",
    className: "st20",
    d: "M35.1,64.6c4.5-2.5,11.9,0.7,11.9,4.3c0,10.6-10.5,60.6-11,63.8c-0.5,3.2-6.4,4-6.7,0 c-0.5-6.3-0.3-28.3,0.7-38.5c0.4-4.2-0.3-8.2,0.1-11.7c-5.5,9.2-14,22.3-25.5,39.4l-6.2-2.6c4.9-14.9,8.9-25.5,12-31.7 C15.8,77.1,20.8,68,22.9,64.9C26.3,59.9,32.1,61.6,35.1,64.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "LegLower",
    className: "st24",
    d: "M-1.2,111l21.4-47c5.1-7.6,19.5,1.6,17.8,6c-4,10.1-24.2,42.6-25.3,45.6L-1.2,111z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Accessories_x2F_Shoe_x2F_Flat-Sneaker",
    transform: "translate(215.500000, 133.000000) rotate(30.000000) translate(-215.500000, -133.000000) translate(185.000000, 113.000000)",
    className: "st25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "shoe",
    className: "st26",
    d: "M-166.5,114.5c-0.6,1.5-1,2.7-1,3.5c0,0.9,0.1,2.3,0.3,4c1.1,0,11.1-0.4,30-1 c0.9-2.5,0.5-3.8-1.2-4c-1.7-0.1-3.1-0.3-4.2-0.4l-13.7-5.5c-0.3-0.1-0.6,0-0.7,0.3c0,0,0,0,0,0l-1,2.1 c-1.6,0.7-2.9,1.1-3.8,1.2c-0.8,0-1.9-0.2-3.2-0.8v0C-165.6,113.6-166.2,113.9-166.5,114.5 C-166.5,114.4-166.5,114.4-166.5,114.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Accessories_x2F_Shoe_x2F_Flat-Sneaker_3_",
    transform: "translate(242.000000, 126.000000)",
    className: "st25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "shoe_3_",
    className: "st26",
    d: "M-214.1,4.2c-0.6,1.5-0.9,2.6-0.9,3.4c0,0.9,0.2,2.2,0.5,4c1.1,0,11.3,0,30.5,0 c0.8-2.4,0.3-3.7-1.4-3.9c-1.7-0.2-3.1-0.4-4.3-0.5l-14.2-5.9c-0.3-0.1-0.6,0-0.7,0.3c0,0,0,0,0,0l-0.9,2.1 c-1.6,0.7-2.9,1-3.9,1c-0.8,0-1.9-0.3-3.3-0.9v0C-213.1,3.4-213.8,3.6-214.1,4.2C-214,4.1-214.1,4.1-214.1,4.2z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Leg-and-Butt",
    className: "st27",
    d: "M48.6,72.5c0,13.3-6.8,44.4-6.8,47.3l-14.7,0c2.2-27.7,2.9-41.8,2.3-42.1 c-0.9-0.4-38.5,3.5-49.7,3.5c-16.2,0-22.9-9.5-23.5-27h32.2c6.5,0.6,40.7,7,53.4,9.2C47.1,64.4,48.6,68.8,48.6,72.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Body_x2F_Pointing-Forward_1_",
    transform: "translate(22.000000, 82.000000)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 51.6154,
    y1: 111.2624,
    x2: 109.9063,
    y2: 111.2624
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F38B12"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EE2616"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M48,106.2L19.4,78.6c-1.6-1.6-3.6-2.4-5.4-2.4c-2.4,0-4.7,1.3-6.1,3.8l-13.1,22.7 c-2.6,4.4-1.7,11,2.1,14.7l27.6,26.6c3.8,3.7,8.7,2.6,12.5-0.4l13.1-22.7C52.8,116.5,51.8,109.8,48,106.2z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Skin_1_",
    className: "st20",
    d: "M-28.7,128l18.8-9.5c3.1-3.4,6.2-6.1,9.2-8c0.9-0.4,2.5-0.6,1,1.9c-1.5,2.5-3,5.2-2.2,5.9 c0.8,0.8,2.7-0.3,3.6,1c0.6,0.9-2.7,2.2-9.9,4l-13.7,11.6L-28.7,128z M0.7,136l8.3-4.2c1.2-4.1,2.5-6.1,4.2-6.2 c1.2-0.5-0.9,4.6,1.4,4.2c2.3-0.4,8.1-4.4,9.1-3.6c1.5,1.2,0.2,4.8-1.4,6.6c-2.9,3.4-5.2,4.5-11.1,6.1c-3.1,0.8-6.4,2.4-9.9,4.8 L0.7,136z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sleeve_2_",
    gradientUnits: "userSpaceOnUse",
    x1: -9.4838,
    y1: 128.0975,
    x2: 21.0611,
    y2: 128.0975
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00AAEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#06EDA4"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Sleeve_1_",
    className: "st29",
    d: "M-37.9,125.8c6.6-0.1,15.4-1.4,24.7-6.9l3.7,7.6c-6.5,5.9-15.5,10.8-23.5,10.6 C-39.2,137-42.4,130-37.9,125.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Clothes_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 11.8252,
    y1: 142.8776,
    x2: 96.4763,
    y2: 142.8776
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#06EDA4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00AAEB"
    }
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Clothes_1_",
    className: "st30",
    d: "M-29,138c7,1.6,18.7-0.3,35.2-5.7c4.1,7.8,6,13.4,5.7,16.7c-14.1,6.8-26.2,9.9-36.2,10.1 c0.3,5.5-0.4,10.7-2.8,15.5c-5,9.8-34.1,0.7-43.9,2.5c-6.1-18.4,5.7-25.9,5.7-37.7c0-12.9,11.2-32.8,12.9-32.8h15 C-36.6,116.4-32.5,127.3-29,138z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "humaaans_x2F_standing-24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "humaaan-11",
    transform: "translate(34.000000, 10.000000)"
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Head_x2F_Front_x2F_Wavy",
    transform: "translate(128.159246, 70.924000) rotate(-15.000000) translate(-128.159246, -70.924000) translate(57.306980, 16.688000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Head",
    transform: "translate(56.316359, 32.329762)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M-123.4,29.6c-2.8-3.3-4.6-7.2-4.3-11.7c0.9-12.9,18.8-10,22.3-3.5s3.1,23-1.4,24.1 c-1.8,0.5-5.6-0.7-9.5-3l2.4,17.3h-14.4L-123.4,29.6z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "hair",
    className: "st32",
    d: "M-47.7,49.6c-0.1-0.8-0.5-1.8-0.8-2.6c-0.4-1-0.9-2-1.5-2.8c-1.1-1.6-2.5-3.1-4-4.4 c-2.8-2.2-6.3-3.5-9.7-3.1c-1.7,0.2-3.4,0.9-4.9,2c-1.3,1-2.6,2.5-4.2,2.6c-1.8,0.1-3.5-1.5-5-2.5c-1.7-1.1-3.4-1.9-5.4-2.3 c-3.2-0.5-6.3,0.6-8.5,3.2c-2.4,2.8-4.1,7-2.5,10.7c0.3,0.7,2.7,12.3,3.9,13.5c1.2,1.2,2.6,1.8,4.2,2.2c1,0.2,2.1,0.3,3.2,0.2 c0.7-0.1,1.3-0.3,2.1-0.4c2.1,1.6,4.4,2.2,6.9,2c1.9-0.2,4.1-0.6,5.6-1.9c1.7-1.4,1.7-3.4,1.3-5.6c0.4,0.2,1.6,0.3,0.9-0.5 c-0.3-0.3-0.8-0.5-1.2-0.7c-0.4-0.2-0.8-0.5-1.2-0.9c-1.3-1.5,0-4.6,1.7-5.1c2.5-0.8,3,2.7,4.8,3.6c1,0.5,2.1-0.2,2.8-0.9 c1-1,1.7-2.2,2.3-3.5c0.5-1.1,0.9-2.2,1.4-3.2c0.2-0.5,1-1.9,0.6-2.5c1.8-0.4,3.7,0.4,5.2,1.3c0.6,0.4,1.1,0.8,1.4,1.5 c0.1,0.1,0.2,0.6,0.4,0.6C-47.5,50.2-47.7,49.8-47.7,49.6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Bottom_x2F_Standing_x2F_Skirt",
    transform: "translate(0.000000, 210.685999)"
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Skirt-Shadow",
    className: "st33",
    d: "M-17.2,34.2c14.4,4,26.9,6.1,37.4,6.1s20.2-3.1,29.2-9.3c-14.1-4.1-25.8-6.2-34.9-6.2 S-5.2,27.9-17.2,34.2z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Leg",
    className: "st31",
    d: "M23,44.7c-0.1-0.2-0.3-0.4-0.3-0.7C20.7,38.9-4.9-16.4-8-26.5h34.8c2.3,7.6,12.9,55.7,14.4,65.2 c4.7,15.1,14.3,64,15.5,67.4c1.3,3.6-6,7.3-7.9,2.9c-3.1-7-14.3-29.6-17.5-41.4C28.2,56.6,24.2,50.3,23,44.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Accessories_x2F_Shoe_x2F_Flat-Sneaker_1_",
    transform: "translate(216.922274, 207.536214)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "shoe_4_",
    gradientUnits: "userSpaceOnUse",
    x1: -171.3523,
    y1: -96.4726,
    x2: -136.463,
    y2: -96.4726
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6900FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B600FF"
    }
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "shoe_1_",
    className: "st34",
    d: "M-170.3-99c-0.7,1.8-1,3.1-1,4c0,1.1,0.2,2.7,0.5,4.7c1.3,0,12.6,0,33.9,0 c0.9-2.9,0.4-4.5-1.5-4.7c-1.9-0.2-3.5-0.4-4.7-0.6l-15.8-7c-0.3-0.1-0.7,0-0.8,0.3c0,0,0,0,0,0l-1,2.5 c-1.8,0.8-3.2,1.2-4.3,1.2c-0.9,0-2.1-0.4-3.7-1.1l0,0C-169.3-100-170-99.7-170.3-99C-170.3-99.1-170.3-99.1-170.3-99z"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Leg_2_",
    className: "st31",
    d: "M-6.7,40.9c0-0.2-0.1-0.5,0-0.8c0.3-5.4-0.9-68.9,0.3-79.3l26.7,14.5 c-0.9,7.9-6.8,54.4-9.2,63.8C9.3,54.9-5.1,105.3-5.3,108.9c-0.2,3.8-8.4,4.3-8.4-0.5c0-7.6,0.9-28.3,2.6-40.4 C-9.5,56.7-7.8,46.6-6.7,40.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Accessories_x2F_Shoe_x2F_Flat-Sneaker_2_",
    transform: "translate(216.922274, 207.536214)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "shoe_5_",
    gradientUnits: "userSpaceOnUse",
    x1: -236.3695,
    y1: -89.9868,
    x2: -203.6548,
    y2: -89.9868
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6900FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B600FF"
    }
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "shoe_2_",
    className: "st35",
    d: "M-232.4-100.5c-1.3,1.4-2.2,2.5-2.5,3.3c-0.4,1-0.9,2.5-1.4,4.6c1.2,0.5,11.5,5,31.1,13.6 c2-2.3,2.1-4,0.5-4.9c-1.6-1-3-1.8-4.1-2.5l-11.6-12.7c-0.2-0.2-0.6-0.3-0.8,0c0,0,0,0,0,0l-1.9,1.8c-1.9,0-3.4-0.1-4.4-0.6 c-0.8-0.4-1.8-1.2-3-2.5h0C-231.1-101-231.9-101-232.4-100.5C-232.4-100.6-232.4-100.5-232.4-100.5z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Skirt_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -19.4472,
    y1: 3.5924,
    x2: 49.3444,
    y2: 3.5924
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#06EDA4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00AAEB"
    }
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Skirt",
    className: "st36",
    d: "M-5.4-24.8c13.6-3.9,26.4-3.9,38.5,0C37.3-5.5,47.5,2.1,49.3,31.5 c-20.5,10.2-45.7-7.2-66.8,2.7C-23.4,20.3-15-13-5.4-24.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Body_x2F_Pointing-Forward",
    transform: "translate(155.249818, 199.734499) rotate(-10.000000) translate(-155.249818, -199.734499) translate(21.880847, 102.214000)"
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M6.4,11.3l22-9.1c3.9-3.7,7.6-6.5,11.2-8.4c1.1-0.3,2.9-0.4,0.9,2.4c-2,2.8-4,5.8-3.2,6.8 c0.8,1,3,0,3.9,1.6c0.6,1.1-3.2,2.3-11.4,3.6L13.1,20.3L6.4,11.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sleeve_3_",
    gradientUnits: "userSpaceOnUse",
    x1: -5.7333,
    y1: 8.8501,
    x2: 27.8266,
    y2: 8.8501
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EE2616"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1834,
    style: {
      stopColor: "#EE2B16"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3893,
    style: {
      stopColor: "#EF3815"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6062,
    style: {
      stopColor: "#F04F14"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829,
    style: {
      stopColor: "#F26E13"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F38B12"
    }
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Sleeve",
    className: "st37",
    d: "M-3.5,7.6c7.3,0.7,17.1,0.2,28.2-5.2l3.1,9.5c-7.9,6.3-18.6,11-27.3,9.8 C-6.4,20.8-9,12.1-3.5,7.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 32.3916,
    y1: 2.2851,
    x2: 108.2231,
    y2: 2.2851
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF954B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF0E95"
    }
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M74.1,46L32.9,15.1c-2.3-1.7-2.7-5.4-0.5-8.3l24.9-33.2c2.1-2.7,5.7-3.7,8.1-1.8l41.1,30.9 c2.3,1.7,2.7,5.4,0.5,8.3L82.1,44.1C80,47,76.4,47.7,74.1,46z"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "st22"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M72.8,37.4L41.1,13.6c-1.8-1.3-2.1-4.2-0.4-6.4l19.2-25.6c1.6-2.1,4.4-2.8,6.2-1.4L97.8,4 c1.8,1.3,2.1,4.2,0.4,6.4L79,36C77.4,38.2,74.6,38.7,72.8,37.4z"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M87.2,14.1L71,26c-1.8,1.3-4.4,0.1-4.6-2.1l-0.7-34.8c-0.2-2.4-3-3.5-4.8-1.9L45.3,7.7 c-1.4,1.2-1.3,3.4,0.2,4.5l27.6,20.5c1.3,0.9,3.1,0.7,4-0.6l12-16.1C90,14.8,88.4,13.2,87.2,14.1z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st41",
    cx: 77.5,
    cy: 6.5,
    r: 5.3
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M55.6,31.4l9.2-5c1.3-4.9,2.8-7.4,4.6-7.4c1.4-0.6-1,5.5,1.6,5c2.6-0.5,9-5.3,10.1-4.3 c1.6,1.4,0.2,5.8-1.5,8c-3.2,4.1-5.8,5.4-12.3,7.3c-3.4,0.9-7.1,2.9-11.1,5.7L55.6,31.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Clothes_3_",
    gradientUnits: "userSpaceOnUse",
    x1: -28.1502,
    y1: 33.5892,
    x2: 62.1799,
    y2: 33.5892
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F38B12"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EE2616"
    }
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Clothes",
    className: "st43",
    d: "M15.7,34.6c7.8,1.9,20.8-0.3,39.1-6.9c4.5,9.4,6.6,16.1,6.3,20.1 C45.4,56,31.9,59.7,20.9,59.9c-2.9,7-2.7,12.7-3.1,18.5c-5.5,11.7-42.1-6.8-53-4.7c9.4-25.9,10.6-23.4,10.6-37.6 c0-15.5,12.5-39.3,14.3-39.3l16.7,0C7.3,8.7,11.9,21.8,15.7,34.6z"
  }))))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M69.3,133.8c3.2-4.3,6.4-7.8,9.6-10.3c1-0.5,2.8-0.9,1.3,2.2c-1.5,3.1-2.9,6.4-2,7.3c0.9,0.9,3-0.6,4.1,0.9 c0.7,1-2.8,2.8-10.6,5.6L69.3,133.8z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 279.15,
    y1: 216.4457,
    x2: 311.0608,
    y2: 216.4457,
    gradientTransform: "matrix(1 1.666601e-03 -1.666601e-03 1 0.2914 -0.5466)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F2F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F2F2F2",
      stopOpacity: 0.64
    }
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M287.3,208.9c0.1-0.4,0.3-0.8,0.6-1.2c0.4-0.4,0.8-0.5,1-0.4s0.7,0.6,1.3,1.2l11,12.7c0.6,0.7,0.9,1.1,1,1.4 c0.4,0.8,0.2,1.6-0.5,2.4c-0.3,0.3-0.6,0.4-0.8,0.4c-0.3,0-0.5-0.1-0.7-0.3c-0.2-0.2-0.5-0.5-0.9-1l-11-12.8c-0.5-0.6-0.9-1-1-1.3 C287.3,209.7,287.2,209.3,287.3,208.9L287.3,208.9z M287,213l-8,17l1.6,3.3l14-5.1l-1.9-3.8l-9.6,4l5.8-11.5L287,213L287,213z  M309.3,199.5l-14,5.1l2,3.9l9.5-4l-5.7,11.5l1.9,3.8l7.9-17L309.3,199.5z"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M348.8,65.3c-0.4,0.2-0.9,0.3-1.3,0.3c0.5-0.3,0.8-0.7,1-1.2c-0.4,0.3-0.9,0.4-1.4,0.5 c-0.4-0.5-1-0.7-1.6-0.7c-0.6,0-1.1,0.2-1.6,0.7c-0.4,0.4-0.7,1-0.7,1.6c0,0.2,0,0.3,0.1,0.5c-0.9,0-1.8-0.3-2.6-0.7 c-0.8-0.4-1.5-1-2-1.7c-0.2,0.3-0.3,0.7-0.3,1.1c0,0.4,0.1,0.7,0.3,1.1c0.2,0.3,0.4,0.6,0.7,0.8c-0.4,0-0.7-0.1-1-0.3v0 c0,0.5,0.2,1,0.5,1.4c0.3,0.4,0.8,0.7,1.3,0.8c-0.2,0.1-0.4,0.1-0.6,0.1c-0.1,0-0.3,0-0.4,0c0.1,0.4,0.4,0.8,0.8,1.1 c0.4,0.3,0.8,0.4,1.3,0.4c-0.8,0.6-1.7,1-2.8,1c-0.2,0-0.4,0-0.5,0c1,0.7,2.2,1,3.4,1c0.8,0,1.5-0.1,2.2-0.4 c0.7-0.3,1.3-0.6,1.8-1c0.5-0.4,0.9-0.9,1.3-1.5c0.4-0.5,0.6-1.1,0.8-1.7c0.2-0.6,0.3-1.2,0.3-1.8c0-0.1,0-0.2,0-0.3 C348.1,66.2,348.5,65.8,348.8,65.3z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 67.189,
    y1: 67.4384,
    x2: 109.2557,
    y2: 67.4384
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#06EDA4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00AAEB"
    }
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M104.2,72.5h-32c-2.8,0-5-2.3-5-5v0c0-2.8,2.3-5,5-5h32c2.8,0,5,2.3,5,5v0C109.3,70.2,107,72.5,104.2,72.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWporgAstra);
export default __webpack_public_path__ + "static/media/wporg-astra.db0826604b59c17e131fe31c95b027a3.svg";
export { ForwardRef as ReactComponent };